import { AlignLeft } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function ExcelToCSV() {
  const { t } = useLanguage();
  const tk = t.tools.excelToCsv;

  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/excel/excel-to-csv",
    accept: ".xlsx",
    multiple: false,
    resultType: "download",
    resultFileName: tk.result,
    color: "#0891b2",
    Icon: AlignLeft,
    toolKey: "excelToCsv",
  };

  return <ToolPage config={config} />;
}
